import styled from 'styled-components';

export const IconBlockStyled = styled.div`
  height: 100%;
`;
